"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _download = _interopRequireDefault(require("@remote-com/norma/icons/download.svg"));

var _Media = require("../../Ui/Media");

var _FileField = require("./FileField.styled");

var _FileUploadField = require("./FileUploadField.styled");

var __jsx = _react["default"].createElement;

function FileDownload(_ref) {
  var label = _ref.label,
      description = _ref.description,
      filename = _ref.filename,
      url = _ref.url,
      onClick = _ref.onClick;
  return __jsx(_FileUploadField.StyledFileUploadField, null, __jsx(_Media.Media, {
    center: true
  }, __jsx(_Media.MediaBody, null, __jsx(_FileUploadField.FieldTitle, null, label), description && __jsx(_FileUploadField.FileDescription, null, description)), __jsx(_Media.MediaObject, {
    $preserveSize: true
  }, __jsx(_FileField.FileButton, {
    as: "a",
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    download: filename,
    onClick: onClick
  }, __jsx(_FileField.FileHandle, null, __jsx(_download["default"], null)), __jsx(_FileField.FileLabel, null, __jsx(_FileField.FileLabelTitle, null, "Download"))))));
}

var _default = FileDownload;
exports["default"] = _default;